import Debounce from "../utils/debounce";
import { getDataFromScript } from "../utils/helpers";

export default class CatalogItemTable {
  constructor() {
    this.table = document.getElementById('grid_organization_catalog_items');
    this.catalogs = getDataFromScript('catalog-table-data') || null;
    if ( this.table && this.catalogs ) {
      this.typePicker = document.querySelector('select[name="type"]');
      this.categoryPicker = document.querySelector('select[name="category"]');
      this.catalogPicker = document.querySelector('select[name="catalog"]');
      this.searchInput = document.querySelector('#search-input');
      this.rows = this.table.querySelectorAll('tbody tr');

      this.rows.forEach(( tr, key ) => {
        if (!tr.classList.contains('no-data-row')) {
          tr.setAttribute('data-catalog-id', this.catalogs[key].id);
        }
      });

      const debounce = new Debounce(() => {
        this.filterDataTable()
      }, 200);

      const debouncedFunc = debounce.call();

      this.searchInput.addEventListener('keyup', debouncedFunc);

      [
        this.typePicker,
        this.categoryPicker,
        this.catalogPicker,
      ].forEach( picker => $(picker).chosen().change(this.filterDataTable.bind(this)));

      this.searchInput.value = new URLSearchParams(window.location.search).get('name');

      this.filterDataTable()

      this.onTableItemLinkClick()
    }
  }

  filterByKey(catalogs, value, key) {
    return catalogs.filter( c => c[key] === value || !value);
  }

  filterByCategory(catalogs, value) {
    return catalogs.filter( c => c.category_ids.includes( value ) || !value);
  }

  filterByName = (catalogs, value) => catalogs.filter( c => {
    const name = c.name.toLowerCase();
    const title = c.title.toLowerCase();
    const filter = value.toLowerCase();

    return name.indexOf( filter ) > -1 || title.indexOf( filter ) > -1 || !value
  });

  buildURLQueryParams(param) {
    const url = new URL(window.location.href);

    if ( param.value ) {
      url.searchParams.set(param.key, param.value);
    } else {
      url.searchParams.delete(param.key);
    }

    window.history.pushState({ path: url.href }, '', url.href);
  }

  onTableItemLinkClick() {
    const links = this.table.querySelectorAll('tbody tr td > a');

    links.forEach(( elem ) => {
      elem.setAttribute('data-href', elem.href)
      elem.setAttribute('href', 'javascript:void(0)')

      elem.addEventListener('click', (e) => {
        e.preventDefault()

        let anchor = e.target;
        if (anchor.nodeName !== 'A') {
          anchor = anchor.closest('a');
        }

        const url = new URL(anchor.dataset.href + window.location.search)

        const catalogIdScope = document.querySelector(`script[catalog-table-data]`).dataset.catalogId;
        if (catalogIdScope && window.location.search) {
          url.searchParams.set('catalog_id', catalogIdScope);
        }

        window.location = url.href
      })
    });
  }

  filterDataTable() {
    let catalogsFiltered = this.catalogs;
    catalogsFiltered = this.filterByName(catalogsFiltered, this.searchInput.value);
    catalogsFiltered = this.filterByKey(catalogsFiltered, this.typePicker.value, 'type');
    catalogsFiltered = this.filterByKey(catalogsFiltered, this.catalogPicker?.value, 'catalog_id');
    catalogsFiltered = this.filterByCategory(catalogsFiltered, this.categoryPicker.value);

    const params = [
      {
        key: 'name',
        value: this.searchInput.value
      },
      {
        key: 'type',
        value: this.typePicker.value
      },
      {
        key: 'catalog_id',
        value: this.catalogPicker?.value
      },
      {
        key: 'category',
        value: this.categoryPicker.value
      },
    ]

    for (const { key, value } of params) {
      this.buildURLQueryParams({ key, value })
    }

    const catalogIdsToShow = catalogsFiltered.map( c => c.id );

    this.rows.forEach(( tr ) => {
      if (tr.hasAttribute('data-catalog-id') && catalogIdsToShow.indexOf(tr.getAttribute('data-catalog-id')) === -1) {
        tr.classList.add('d-none');
      } else {
        tr.classList.remove('d-none');
      }
    });
  }
}
